/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../components/Dialog/Dialog';
import DialogTitle from '../../../components/DialogTitle/DialogTitle';
import DialogContent from '../../../components/DialogContent/DialogContent';
import Grid from '../../../components/Grid/Grid';
import Typography from '../../../components/Typography/Typography';
import Button from '../../../components/Button/Button';

const ProcessStartPreCheckDialog = ({
  transId,
  isOpen,
  onClose,
  processTitle,
  resultRows,
  onForceStart,
  precheckResult,
}) => {
  const { processStartPreCheckResult, processStartPreCheckResultMessage } = precheckResult || {};
  const handleForceStart = () => {
    onForceStart?.();
  };

  const handleClose = () => {
    onClose?.();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      maxWidth={resultRows?.length > 0 ? 'md' : 'sm'}
    >
      <DialogTitle>無法開始{processTitle}</DialogTitle>
      <DialogContent>
        <p>
          {processStartPreCheckResultMessage ||
            `移轉單${transId}尚未完成前置作業，無法開始${processTitle}。`}
        </p>
        {resultRows?.length > 0 && (
          <>
            <Grid container fullWidth>
              <Grid xs={6}>
                <Typography variant="subtitle2">試燒單號</Typography>
              </Grid>
              <Grid xs={4}>
                <Typography variant="subtitle2">試燒日期</Typography>
              </Grid>
              <Grid xs={2}>
                <Typography variant="subtitle2" sx={{ textAlign: 'right' }}>
                  結果
                </Typography>
              </Grid>
            </Grid>
            {resultRows.map((row) => (
              <Grid container fullWidth key={row.pilotTransId} sx={{ mt: 1 }}>
                <Grid xs={6} sx={{ flexDirection: 'column', gap: 0.5 }}>
                  <Typography>{row.pilotTransId}</Typography>
                  {row.sourceTransId && (
                    <Typography variant="caption">來源：{row.sourceTransId}</Typography>
                  )}
                </Grid>
                <Grid xs={4}>
                  <Typography>{row.pilotTransferDate}</Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography
                    sx={{ textAlign: 'right', fontWeight: row.pilotQcResult ? 'normal' : 'bold' }}
                  >
                    {typeof row.pilotQcResult === 'boolean'
                      ? row.pilotQcResult
                        ? 'OK'
                        : 'NG'
                      : '無'}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </>
        )}
      </DialogContent>
      <Grid container justifyContent="end" sx={{ px: 2.5, pt: 0, pb: 2 }} gap={1}>
        <Button
          variant="contained"
          color="primay"
          onClick={handleClose}
          sx={{
            fontWeight: 500,
            bgcolor: 'grey.400',
            color: 'white',
            '&:hover': { bgcolor: 'grey.500' },
          }}
        >
          取消
        </Button>
        <Button variant="contained" color="primary" onClick={handleForceStart}>
          強制開始
        </Button>
      </Grid>
    </Dialog>
  );
};

ProcessStartPreCheckDialog.propTypes = {
  transId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onForceStart: PropTypes.func.isRequired,
  processTitle: PropTypes.string.isRequired,
  resultRows: PropTypes.arrayOf(
    PropTypes.shape({
      sourceTransId: PropTypes.string.isRequired,
      pilotTransferDate: PropTypes.string.isRequired,
      pilotQcResult: PropTypes.bool.isRequired,
      pilotTransId: PropTypes.string.isRequired,
    })
  ).isRequired,
  precheckResult: PropTypes.shape({
    processStartPreCheckResult: PropTypes.string.isRequired,
    processStartPreCheckResultMessage: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProcessStartPreCheckDialog;
